const {__} = wp.i18n

const body = document.body

const setThemeVars = () => {
    const test = __('Test JS translation', 'kb')
    const documentWidth = document.documentElement.clientWidth
    const width = Math.abs(window.innerWidth - documentWidth)
    body.style.setProperty('--scrollbar-width', `${width}px`)

    const mainContainer = document.querySelector('footer')
    const mainContainerWidth = mainContainer.clientWidth

    const col = document.querySelector('.kb-col-sizer')
    const colWidth = col.clientWidth

    const headerContainer = document.querySelector('header')
    if (headerContainer) {
        const headerContainerHeight = headerContainer.clientHeight
        body.style.setProperty('--header-height', `${headerContainerHeight}px`)
    }

    body.style.setProperty(
        '--space-width',
        `${(documentWidth - mainContainerWidth) / 2 + 20}px`
    )

    body.style.setProperty('--container-width', `${mainContainerWidth}px`)
    body.style.setProperty('--main-width', `${documentWidth}px`)
    body.style.setProperty('--col-width', `${colWidth}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

document.addEventListener('DOMContentLoaded', function (dom) {
    const phoneLinks = dom.target.querySelectorAll('[href^="tel:"]')
    if (phoneLinks.length) {
        phoneLinks.forEach((el) => {
            el.classList.add('gtm_phone')
        })
    }

    const mailLinks = dom.target.querySelectorAll('[href^="mailto:"]')
    if (mailLinks.length) {
        mailLinks.forEach((el) => {
            el.classList.add('gtm_mail')
        })
    }

    const openCookie = dom.target.querySelector('footer .cookies')
    if (openCookie) {
        openCookie.addEventListener('click', function (e) {
            e.preventDefault()
            openAxeptioCookies()
        })
    }
})
